export default "__VITE_ASSET__PlEO7x1m__"